import {
  DialogActions,
  FormControlLabel,
  Checkbox,
  ButtonGroup,
  Button,
} from "@mui/material";
import Grid from "@mui/material/Grid";
import { styled } from "@mui/material/styles";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import Typography from "@mui/material/Typography";
import _ from "lodash";
import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";
import { v4 as uuid } from "uuid";

import PermissionTab from "./component-properties/PermissionTab";
import {
  MINUTE,
  GRID,
  OPTIONLIST,
  CHECKBOXLIST,
  STEPPER,
  DYNAMICLIST,
} from "./constants";
import {
  renderPreview,
  findIndexDefaultValue,
  getTabContent,
  getPropertieObjectById,
  llFindChildrenById,
  llDeleteNodeById,
  llEditNodeById,
  mergeValuesFromPropertie,
} from "./helper";
import GenericModal from "../../../components/modal-closebtn";
import { useDatalists } from "../../../hooks/datalist";
import { useDocumentTypes } from "../../../hooks/documentTypes";
import {
  useMetadataById,
  useMetadataCreate,
  useMetadataTypes,
} from "../../../hooks/metadata";
import { useTemplateList } from "../../../hooks/useTemplateList";
import { language } from "../../../language";
import { findObjectInChildren } from "../../DocumentsSmartDocz/Wizard/helpers";
import { getUnitPropertie } from "../../smart/camunda/forms/functions";

const PreviewContainer = styled("div")(({ theme }) => ({
  padding: "3%",
  height: "55vh",
  maxHeight: "100vh",
}));

const LayoutContainer = styled("div")(({ theme }) => ({
  height: "75vh",
}));

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`wrapped-tabpanel-${index}`}
      aria-labelledby={`wrapped-tab-${index}`}
      {...other}
    >
      {children}
    </Typography>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function PropertiesModal(props) {
  const {
    manage,
    edit,
    setEditComponent,
    open,
    uploadFileTemplatePDF,
    documentTemplatePDF,
    expanded,
    menuTree,
    menuExpanded,
    menuHighlighted,
    tree,
    allFormFields,
    businessObject,
  } = props;

  const [value, setValue] = React.useState(0); // Value da tab
  const [objeto, setobjeto] = useState({}); // State com o objeto manipulado
  const [error, seterror] = useState({}); // State com o objeto manipulado
  const [authMembers, setauthMembers] = useState([]); // State com os usuários/groups mapeados em permissões
  const [auxState, setAuxState] = useState([]); // State auxiliar
  const [saveMetadata, setsaveMetadata] = useState(false);
  const [selectedDocumentType, setSelectedDocumentType] = useState(null);

  const item = edit
    ? manage
    : manage && manage.payload && manage.payload.element;

  const { mutate: createMetadata } = useMetadataCreate();

  const { data: metadatasTypes } = useMetadataTypes({});
  const { data: metadataId, refetch: fetchGetMetadataById } = useMetadataById({
    enabled: false,
    param: item.id,
  });
  const { data: docTypes, refetch: fetchDocumentTypes } = useDocumentTypes({
    enabled: false,
    params: { isPageable: false },
  });
  const { data: dataList, refetch: fetchDataList } = useDatalists({
    enabled: false,
    params: { isPageable: false },
  });
  const { data: documentTemplates, refetch: fetchDocumentTemplates } =
    useTemplateList({
      enabled: false,
      params: { isPageable: false, byDocumentType: selectedDocumentType },
    });

  useEffect(() => {
    if (!selectedDocumentType) return;
    fetchDocumentTemplates();
  }, [selectedDocumentType]);

  // Styled components are now used instead of classes
  const { handleSubmit, handleClose } = props;

  const RequiredField = () => {
    const customProps = objeto.properties ? Array.from(objeto.properties) : [];
    const modelIsRequired = getPropertieObjectById(customProps, "isRequired");
    const modelRegex = getPropertieObjectById(customProps, "regex");
    const retorno = [];
    if (modelIsRequired && modelIsRequired.value === true) {
      const modelRequired = getPropertieObjectById(customProps, "required");
      if (!modelRequired || modelRequired.value.length === 0) {
        retorno.push({ id: "required" });
      }
    }
    if (modelRegex && modelRegex.value.length > 0) {
      const modelmessage = getPropertieObjectById(customProps, "messageRegex");
      if (!modelmessage || modelmessage.value.length === 0) {
        retorno.push({ id: "messageRegex" });
      }
    }

    try {
      if (objeto && objeto.type === STEPPER) {
        const steps = getUnitPropertie(objeto, "steps") || [];
        const hasInvalid =
          !Array.isArray(steps) ||
          steps.length === 0 ||
          steps.some(
            (s) => !s || !s.name || String(s.name).trim().length === 0,
          );
        if (hasInvalid) {
          retorno.push({ id: "steps" });
        }
      }
    } catch (e) {
      retorno.push({ id: "steps" });
    }

    return retorno;
  };

  // Método para enviar o item manipulado
  const handleClick = (event) => {
    const errors = RequiredField();

    if (errors.length === 0) {
      edit
        ? setEditComponent(objeto)
        : handleSubmit(
            {
              addedIndex: manage.addedIndex,
              removedIndex: manage.removedIndex,
              payload: objeto,
            },
            true,
          );

      seterror({});
      handleModalClose(true);

      if (saveMetadata) {
        createMetadata({
          type: metadatasTypes.filter((type) => type.name === objeto.type)[0],
          id: objeto.id,
          name: objeto.name,
          description: objeto.description,
          properties: JSON.stringify(objeto.properties),
        });
      }
    } else {
      seterror(errors);
    }
  };

  const DisplayTab = getTabContent("DisplayTab", item);
  const ValidationTab = getTabContent("ValidationTab", item);
  const StylesTab = getTabContent("StylesTab", item);

  useEffect(() => {
    const newId = uuid();
    !edit && item && (item.id = `${item.type}_${newId.substring(0, 6)}`);

    // Copia o componente para ser manipulado no state
    item && setobjeto(item);
    setValue(0);

    if (edit) {
      fetchGetMetadataById();
    }

    if (item.type === MINUTE) {
      fetchDocumentTypes();
    } else if (item.type === OPTIONLIST || item.type === CHECKBOXLIST) {
      fetchDataList();
    }

    return () => {
      setauthMembers([]);
    };
  }, [item, edit, setauthMembers, setobjeto]);

  // carrega a lista de template de acordo com o tipo de documento
  useEffect(() => {
    if (item.type === MINUTE) {
      const documentType = getUnitPropertie(item, "documentType");

      if (documentType && documentType.id) {
        setSelectedDocumentType(documentType.id);
      }
    }
  }, [item]);

  useEffect(() => {
    function getAuthorizationMembers() {
      const response = mergeValuesFromPropertie("editAuth", "viewAuth", objeto);
      response && edit && setauthMembers(response);
    }

    value === 3 && getAuthorizationMembers();
    //value === 3 && !members && fetchUserGroups();
  }, [value, objeto, edit]);

  useEffect(() => {
    !edit &&
      documentTemplatePDF &&
      setobjeto({ ...objeto, documentTemplatePDF });
  }, [documentTemplatePDF, edit, objeto, setobjeto]);

  useEffect(() => {
    const jsonObjetoEntrada =
      props.engineRuleById &&
      props.engineRuleById.objetoEntrada &&
      props.engineRuleById.objetoEntrada.modelo;

    props.engineRuleById &&
      setobjeto((prev) => ({
        ...prev,
        inputObject: JSON.stringify(jsonObjetoEntrada),
      }));
  }, [props.engineRuleById, setobjeto]);

  useEffect(() => {
    metadataId && setsaveMetadata(true);
  }, [metadataId]);

  // // carrega arvore de documentos
  // useEffect(() => {
  //   fetchTreeGetData({ menuTree, menuExpanded });
  // }, [fetchTreeGetData]);

  // Handle Change do painel
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  // HandleChange para o state auxiliar
  const handleAuxChange = (event) => {
    const { name, value } = event.target;
    setAuxState({ ...auxState, [name]: value });
  };

  // Método handleChange para inputs
  const handleChage = (event) => {
    const { name, value } = event.target;
    setobjeto({ ...objeto, [name]: value });
  };

  // Método handleChange para propriedades
  const handlePropertieChange = (event) => {
    const { name, value } = event.target;

    const customProps = objeto.properties ? Array.from(objeto.properties) : [];
    const model = getPropertieObjectById(customProps, name);

    if (model) {
      model.value = value;
    } else {
      customProps.push({ id: name, value, text: name, type: "text" });
    }

    setobjeto({
      ...objeto,
      properties: customProps,
    });
  };

  const handleMultiSelectChange = (selectedValues, name) => {
    const customProps = objeto.properties ? Array.from(objeto.properties) : [];
    const model = getPropertieObjectById(customProps, name);

    if (model) {
      model.value = selectedValues;
    } else {
      customProps.push({
        id: name,
        value: selectedValues,
        text: name,
        type: "multiSelect",
      });
    }

    setobjeto({
      ...objeto,
      properties: customProps,
    });
  };

  const handleSelectFolder = (nodeId, name) => {
    const customProps = objeto.properties ? Array.from(objeto.properties) : [];
    const model = getPropertieObjectById(customProps, name);
    const nodeObject = findObjectInChildren(tree, nodeId);

    if (nodeObject && nodeObject.documentType.name !== "Folder") {
      //se o tipo não for uma pasta então retorna
      return;
    }

    if (model) {
      model.value = nodeId;
    } else {
      customProps.push({ id: name, value: nodeId, text: name, type: "text" });
    }

    setobjeto({
      ...objeto,
      properties: customProps,
    });
  };

  const handleToggle = (value) => {
    const customProps = objeto.properties ? Array.from(objeto.properties) : [];
    const model = getPropertieObjectById(customProps, "acceptedFiles");

    if (model) {
      model.value = value;
    } else {
      customProps.push({
        id: "acceptedFiles",
        value,
        text: "acceptedFiles",
        type: "text",
      });
    }

    setobjeto({
      ...objeto,
      properties: customProps,
    });
  };

  // Método handleChange para check boxes
  const handleCheckChange = (event) => {
    const { name, checked } = event.target;

    let props = objeto.properties;
    const model = getPropertieObjectById(props, name);

    if (model) {
      model.value = checked;
    } else {
      props = props || [];
      props.push({ id: name, value: checked, text: name, type: "boolean" });
    }

    setobjeto({
      ...objeto,
      properties: props,
    });
  };

  // (SELECT - SELECT BOXES) - Adicionar linhas na tabela
  const handleDefaultValueChange = (event, key, propertieId) => {
    const { name, value } = event.target;
    const index = findIndexDefaultValue(objeto, propertieId);
    const helper = objeto;

    if (name === "api") {
      helper.properties[index].value = value;
    } else {
      helper.properties[index].value[key] = {
        ...helper.properties[index].value[key],
        [name]: value,
      };
    }

    setobjeto((prev) => ({ ...prev, properties: helper.properties }));
  };

  // OnBlurApi  - Adicionar linhas na tabela
  const handleDefaultValueChangeOnBlurApi = (event, key, propertieId) => {
    const { name, value } = event.target;
    const index = findIndexDefaultValue(objeto, propertieId);
    const helper = objeto;

    helper.properties[index].mapFields[key] = {
      ...helper.properties[index].mapFields[key],
      [name]: value,
    };

    setobjeto((prev) => ({ ...prev, properties: helper.properties }));
  };

  // (SELECT - SELECT BOXES) - Adicionar linhas na tabela
  const addRowDefaultValue = (propertieId) => {
    const index = findIndexDefaultValue(objeto, propertieId);

    const helper = objeto;
    if (propertieId === "documentOptions") {
      helper.properties[index].value.push({
        tipo: "",
        obrigatorio: false,
        variableId: "",
      });
    } else {
      helper.properties[index].value.push({ key: 0, value: 0, text: 0 });
    }

    setobjeto((prev) => ({ ...prev, properties: helper.properties }));
  };

  //onBlur_api  - Adicionar linhas na tabela
  const addRowDefaultValueOnBlurApi = (propertieId) => {
    const props = objeto.properties;
    const model = getPropertieObjectById(props, propertieId);

    if (model) {
      model.mapFields.push({ api: "", smart: "" });
    }

    setobjeto({
      ...objeto,
      properties: props,
    });
  };

  const deleteDefaultValueRow = (indice, propertieId) => {
    const index = findIndexDefaultValue(objeto, propertieId);

    const helper = objeto;
    helper.properties[index].value.splice(indice, 1);

    setobjeto((prev) => ({ ...prev, properties: helper.properties }));
  };

  //onBlur_api
  const deleteDefaultValueRowOnBlurApi = (indice, propertieId) => {
    const index = findIndexDefaultValue(objeto, propertieId);

    const helper = objeto;
    helper.properties[index].mapFields.splice(indice, 1);

    setobjeto((prev) => ({ ...prev, properties: helper.properties }));
  };

  //extraFields_api  - Adicionar linhas na tabela
  const addRowDefaultValueOnExtraFieldsApi = (event, propertieId) => {
    const props = objeto.properties;
    const model = getPropertieObjectById(props, propertieId);

    if (model) {
      model.mapFields.push({ api: "", smart: "" });
    } else {
      props.push({
        id: propertieId,
        mapFields: [{ api: "", smart: "" }],
      });
    }

    setobjeto({
      ...objeto,
      properties: props,
    });
  };

  //extraFields_api
  const deleteDefaultValueRowExtraFieldsApi = (indice, propertieId) => {
    const index = findIndexDefaultValue(objeto, propertieId);

    const helper = objeto;
    helper.properties[index].mapFields.splice(indice, 1);

    setobjeto((prev) => ({ ...prev, properties: helper.properties }));
  };

  const setTypeOfDefaultValue = (event) => {
    const { name, value } = event.target;
    const index = findIndexDefaultValue(objeto, name);

    let props = objeto.properties;
    let model = getPropertieObjectById(props, name);

    if (name === "options") {
      if (index < 0) {
        props.push({ id: "options", value: [], type: value });
      } else {
        model = { id: "options", value: [], type: value };
        props[index] = model;
      }

      // chama api de lista de dados
      if (value === "dataList") {
        // fetchGetDataList({
        //   isPageable: false,
        // });
      }
    } else if (name === "onBlur_api") {
      if (index < 0) {
        props = typeof props === "object" ? props : [];
        props.push({ id: name, value, mapFields: [] });
      } else {
        model.value = value;
      }
    } else if (name === "documentOptions") {
      if (index < 0) {
        props = typeof props === "object" ? props : [];
        props.push({ id: "documentOptions", value: [], type: value });
      } else {
        model = { id: "documentOptions", value: [], type: value };
        props[index] = model;
      }
    }

    setobjeto((prev) => ({ ...prev, properties: props }));
  };

  const clearPropertie = (propertie) => {
    const index = findIndexDefaultValue(objeto, propertie);
    let arrClear = [];
    arrClear = objeto;

    if (index > -1 && arrClear !== []) {
      arrClear.properties.splice([index], 1);
      setobjeto((prev) => ({ ...prev, properties: arrClear }));
    }
  };

  //manipula o linkedList
  const addLinkedListNode = (event, id) => {
    const helper = objeto.properties;
    const listaPropIndex = findIndexDefaultValue(objeto, "lista");

    const listaPropertie = helper[listaPropIndex].value.lista;

    const obj = llFindChildrenById(listaPropertie, id);
    obj &&
      obj.lista &&
      obj.lista.push({
        id: "default",
        uuid: uuid(),
        value: 0,
        label: "default",
        lista: [],
      });
    helper[listaPropIndex].value.lista = listaPropertie;

    setobjeto((prev) => ({ ...prev, properties: helper }));
  };

  const deleteLinkedListNode = (event, id) => {
    const helper = objeto.properties;
    const listaPropIndex = findIndexDefaultValue(objeto, "lista");
    const listaPropertie = helper[listaPropIndex].value.lista;

    llDeleteNodeById(listaPropertie, id);
    helper[listaPropIndex].value.lista = listaPropertie;
    setobjeto((prev) => ({ ...prev, properties: helper }));
  };

  const editLinkedListNode = (obj, id) => {
    const helper = objeto.properties;
    const listaPropIndex = findIndexDefaultValue(objeto, "lista");
    const listaPropertie = helper[listaPropIndex].value.lista;

    llEditNodeById(listaPropertie, obj, id);
    helper[listaPropIndex].value.lista = listaPropertie;
    setobjeto((prev) => ({ ...prev, properties: helper }));
  };

  // DATA TABLE - Adicionar Linha na tabela de configuração do cabeçalho e no cabeçalho
  const dataTableAddRowDefaultValue = () => {
    const props = objeto.properties;
    const tableHeaders = getPropertieObjectById(props, "tableHeaders");

    tableHeaders.value.push({
      field: Math.random().toString(36).slice(2),
      title: language.smartFormDataTableChangeMe,
    });

    setobjeto((prev) => ({ ...prev, tableHeaders }));
  };

  // (DATA TABLE - editar os campos do cabeçalho
  const dataTableHandleDefaultValueChange = (event, index) => {
    const { name, value } = event.target;
    const props = objeto.properties;
    const tableHeaders = getPropertieObjectById(props, "tableHeaders");

    tableHeaders.value[index][name] = value;

    setobjeto((prev) => ({ ...prev, tableHeaders }));
  };

  // (DATA TABLE - Remover cabeçalho
  const dataTableDeleteDefaultValueRow = (indice) => {
    const props = objeto.properties;
    const tableHeaders = getPropertieObjectById(props, "tableHeaders");

    tableHeaders.value.splice(indice, 1);

    setobjeto((prev) => ({ ...prev, tableHeaders }));
  };

  const handlePropertieChangeDocumentType = (event) => {
    const { name, value } = event.target;

    const customProps = objeto.properties ? Array.from(objeto.properties) : [];
    const model = getPropertieObjectById(customProps, name);

    if (model) {
      model.value = value;
    } else {
      customProps.push({ id: name, value, text: name, type: "text" });
    }

    setobjeto({
      ...objeto,
      properties: customProps,
    });

    if (value && value.id) {
      setSelectedDocumentType(value.id);
    }
  };

  const handlePropertieChangeDataList = (event) => {
    const { name, value } = event.target;

    const customProps = objeto.properties ? Array.from(objeto.properties) : [];
    const model = getPropertieObjectById(customProps, name);

    if (model) {
      model.value = { id: value?.id, name: value?.name };
    } else {
      customProps.push({
        id: name,
        value: { id: value?.id, name: value?.name },
        text: name,
        type: "text",
      });
    }

    setobjeto({
      ...objeto,
      properties: customProps,
    });
  };

  function handleModalClose(fromModal) {
    setobjeto((prev) => {
      const old = { ...prev };
      old.helper = null;
      old.object = null;
      old.properties = null;
      return { ...prev, ...old };
    });

    handleClose(fromModal);
  }

  function handleAutoCompleteChange(e, value) {
    value &&
      value.length < authMembers.length &&
      handleAutoCompleteDelete(value, authMembers);
    setauthMembers([...value]);
  }

  function handleAutoCompleteDelete(newState, state) {
    const dif = _.difference(state, newState);

    if (dif.length > 0) {
      const indexEdit = findIndexDefaultValue(objeto, "editAuth");
      const indexView = findIndexDefaultValue(objeto, "viewAuth");

      if (indexEdit >= 0) {
        const newValue = objeto.properties;

        dif.map((el) => {
          return _.remove(newValue[indexEdit].value, (item) => {
            return item === el;
          });
        });

        setobjeto({
          ...objeto,
          properties: newValue,
        });
      }

      if (indexView >= 0) {
        const newValue = objeto.properties;

        dif.map((el) => {
          return _.remove(newValue[indexView].value, (item) => {
            return item === el;
          });
        });

        setobjeto({
          ...objeto,
          properties: newValue,
        });
      }
    }
  }

  function handleAuthCheck(event, name, type) {
    const checked = event.target.checked;

    const index = findIndexDefaultValue(objeto, type);

    if (index < 0) {
      objeto.properties.push({
        id: type,
        value: [name],
        text: type,
        type,
      });
    } else {
      const newValue = objeto.properties;

      if (newValue) {
        if (!checked) {
          newValue && newValue[index].value.slice(name, 1);
          _.remove(newValue[index].value, (item) => {
            return item.id === name.id;
          });
        } else {
          newValue && newValue[index].value.push(name);
        }

        setobjeto({
          ...objeto,
          properties: newValue,
        });
      }
    }
  }

  function engineConnectFields(ruleField, formField) {
    const props = objeto.properties;
    const model = getPropertieObjectById(props, "mappedFields");

    if (model) {
      model.value.push({
        id: uuid(),
        engineField: ruleField,
        formField,
      });
    } else {
      props &&
        props.push({
          id: "mappedFields",
          text: "mappedFields",
          type: "object",
          value: [{ id: uuid(), engineField: ruleField, formField }],
        });
    }

    setobjeto({
      ...objeto,
      properties: props,
    });

    setAuxState([]);
  }

  function engineDeleteConnectField(index) {
    const props = objeto.properties;
    const model = getPropertieObjectById(props, "mappedFields");

    if (model) {
      _.remove(model.value, (item) => {
        return item.id === index;
      });

      setobjeto({
        ...objeto,
        properties: props,
      });
    }
  }

  const handleChangeSaveMetadata = () => {
    setsaveMetadata(!saveMetadata);
  };

  function renderDialogActions() {
    return (
      <DialogActions style={{ padding: "0  2%" }}>
        <Grid container justify="space-between">
          <Grid item>
            {item && item.type !== GRID && (
              <FormControlLabel
                control={
                  <Checkbox
                    checked={saveMetadata}
                    onChange={handleChangeSaveMetadata}
                  />
                }
                label={language.SaveAsMetadata}
                disabled={metadataId}
              />
            )}
          </Grid>

          <Grid item>
            <ButtonGroup>
              <Button
                variant="contained"
                size="large"
                color="secondary"
                onClick={handleClick}
              >
                {language.ok}
              </Button>
            </ButtonGroup>
          </Grid>
        </Grid>
      </DialogActions>
    );
  }

  return (
    <GenericModal
      size="xl"
      open={open}
      title={language.configuration}
      btnActionTitle={language.ok}
      handleSubmit={handleClick}
      handleClose={handleModalClose}
      removeDropClick
      overrideDialogActions={renderDialogActions}
    >
      <Grid container direction="row">
        <Grid item size={12}>
          <Tabs
            value={value}
            indicatorColor="secondary"
            textColor="secondary"
            onChange={handleChange}
          >
            <Tab label={language.properties} disabled={!DisplayTab} />
            <Tab label={language.configuration} disabled={!ValidationTab} />
            <Tab label={language.styles} disabled={!StylesTab} />
            <Tab label={language.permissions} />
          </Tabs>
        </Grid>
        <Grid
          item
          size={item?.type !== GRID && item?.type !== DYNAMICLIST ? 7 : 12}
          sx={{ padding: 2 }}
          style={{
            borderRight:
              item?.type !== GRID &&
              item?.type !== DYNAMICLIST &&
              "1px solid #e0e0e0",
          }}
        >
          <TabPanel value={value} index={0}>
            {DisplayTab && (
              <DisplayTab
                state={objeto}
                onChange={(event) => handleChage(event)}
                onCheckChange={(event) => handleCheckChange(event)}
                onPropertieChange={(event) => handlePropertieChange(event)}
                onToggle={(value) => handleToggle(value)}
                error={error}
                uploadFileTemplatePDF={uploadFileTemplatePDF}
                engineProjects={props.engineProjects}
                engineRules={props.engineRules}
                fetchRuleByIdProject={props.fetchRuleByIdProject}
                fetchRuleByID={props.fetchRuleByID}
                clearPropertie={(propertie) => clearPropertie(propertie)}
                disabled={false}
                setObjeto={setobjeto}
              />
            )}
          </TabPanel>
          <TabPanel value={value} index={1}>
            {ValidationTab && (
              <ValidationTab
                state={objeto}
                auxState={auxState}
                onChange={(event) => handleChage(event)}
                onCheckChange={(event) => handleCheckChange(event)}
                onPropertieChange={(event) => handlePropertieChange(event)}
                addRowDefaultValue={(event) => addRowDefaultValue(event)}
                deleteDefaultValueRow={(key, propertieId) =>
                  deleteDefaultValueRow(key, propertieId)
                }
                handleDefaultValueChange={(event, key, propertieId) =>
                  handleDefaultValueChange(event, key, propertieId)
                }
                linkedListDeleteNode={(event, id) =>
                  deleteLinkedListNode(event, id)
                }
                linkedListAddNode={(event, id) => addLinkedListNode(event, id)}
                linkedListEditNode={(event, id) =>
                  editLinkedListNode(event, id)
                }
                handleDefaultValueType={setTypeOfDefaultValue}
                onToggle={(value) => handleToggle(value)}
                handleDefaultValueChangeOnBlurApi={(event, key, propertieId) =>
                  handleDefaultValueChangeOnBlurApi(event, key, propertieId)
                }
                addRowDefaultValueOnBlurApi={(event, propertieId) =>
                  addRowDefaultValueOnBlurApi(event, propertieId)
                }
                deleteDefaultValueRowOnBlurApi={(key, propertieId) =>
                  deleteDefaultValueRowOnBlurApi(key, propertieId)
                }
                addRowDefaultValueOnExtraFieldsApi={(event, propertieId) =>
                  addRowDefaultValueOnExtraFieldsApi(event, propertieId)
                }
                deleteDefaultValueRowExtraFieldsApi={(key, propertieId) =>
                  deleteDefaultValueRowExtraFieldsApi(key, propertieId)
                }
                error={error}
                clearPropertie={(propertie) => clearPropertie(propertie)}
                lines={props.lines}
                engineRuleById={props.engineRuleById}
                handleAuxStateChange={(e) => handleAuxChange(e)}
                engineConnectFields={engineConnectFields}
                engineDeleteConnectField={engineDeleteConnectField}
                dataTableAddRowDefaultValue={dataTableAddRowDefaultValue}
                dataTableHandleDefaultValueChange={
                  dataTableHandleDefaultValueChange
                }
                dataTableDeleteDefaultValueRow={dataTableDeleteDefaultValueRow}
                documentTemplates={documentTemplates}
                docTypes={docTypes}
                setObjeto={setobjeto}
                handleMultiSelectChange={handleMultiSelectChange}
                expanded={expanded}
                tree={tree}
                highlighted={menuHighlighted}
                onNodeSelect={handleSelectFolder}
                // setExpanded={fetchSetExpanded}
                // fetchTreeSetData={fetchTreeSetData}
                allFormFields={allFormFields}
                businessObject={businessObject}
                handlePropertieChangeDocumentType={
                  handlePropertieChangeDocumentType
                }
                handlePropertieChangeDataList={handlePropertieChangeDataList}
                dataList={dataList}
              />
            )}
          </TabPanel>
          {StylesTab && (
            <TabPanel value={value} index={2}>
              <StylesTab
                state={objeto}
                onChange={(event) => handleChage(event)}
                onCheckChange={(event) => handleCheckChange(event)}
                onPropertieChange={(event) => handlePropertieChange(event)}
                error={error}
                setObjeto={setobjeto}
              />
            </TabPanel>
          )}

          <TabPanel value={value} index={3}>
            <PermissionTab
              state={objeto}
              authMembers={authMembers}
              handleCheckAuth={(event, name, type) =>
                handleAuthCheck(event, name, type)
              }
              handleAutoCompleteChange={(event, value) =>
                handleAutoCompleteChange(event, value)
              }
              setObjeto={setobjeto}
            />
          </TabPanel>
        </Grid>

        {item?.type !== GRID && item?.type !== DYNAMICLIST && (
          <Grid item size={4}>
            <PreviewContainer>{renderPreview(objeto)}</PreviewContainer>
          </Grid>
        )}
      </Grid>
    </GenericModal>
  );
}

export default PropertiesModal;
